module.exports = __webpack_public_path__ + "img/+1_0010.96c9b039.png";